import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { FaTrash, FaEdit, FaCheck, FaClipboard, FaTimes } from 'react-icons/fa';

import '../../src/createAdmin.css';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Checkbox,
    Tooltip,
    CircularProgress
} from "@mui/material";
import { Button } from '@mui/material';
import * as XLSX from 'xlsx'; // Import the XLSX library
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import { adminCreateApi, fetchAdminDetails, deleteAdminDetails, updateAdminDetails } from "../api/createAdmin";
import { getApiErrorMessage } from "../utils/apiError";

const CreateAdmin = () => {

    const [AdminDetails, setAdmin] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // starts true so the first paint is the loader, never an empty table
    const [loading, setLoading] = useState(true);

    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");

    const [open, setOpen] = useState(false);
    const [add, setAdd] = useState(false);

    const [Name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [adminId, setAdminID] = useState("");
    const [adsEnabled, setAdsEnabled] = useState(true);
    const [togglingAdsId, setTogglingAdsId] = useState(null);
    const [adminToDelete, setAdminToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    // snapshot of the row as it was opened — used to detect edits
    const [initialForm, setInitialForm] = useState(null);
    const [formErrors, setFormErrors] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        password: ""
    });

    const navigate = useNavigate();

    const TABLE_COLUMNS = 9;
    // keeps the table the same height as a full 10-row page while empty/loading
    const PAGE_SIZE = 10;
    const ROW_HEIGHT = 62;
    const EMPTY_TABLE_HEIGHT = PAGE_SIZE * ROW_HEIGHT;

    // Top-right, auto dismiss, solid green/red background
    const TOAST_OPTIONS = {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
    };

    const getAdmin = async (page = 1) => {
        setLoading(true);
        try {
            const data = await fetchAdminDetails(page, PAGE_SIZE);
            console.log(data, "data")

            setAdmin(Array.isArray(data?.data?.data) ? data.data.data : []);
            setTotalPages(data?.data?.totalPages || 1);
            setCurrentPage(data?.data?.currentPage || page);
        } catch (error) {
            console.error('Error fetching wallets:', error);
            // fall through to the No Data state instead of stale rows
            setAdmin([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log(currentPage, "currentPage")
        getAdmin(currentPage);
    }, [currentPage]);



    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            console.log(newPage, "'newPage")
            setCurrentPage(newPage);
        }
    };

    const handleBackClick = () => {
        navigate('/dashboard');
    };

    const ADMIN_NAME_MAX_LENGTH = 150;
    const ADMIN_NAME_MAX_LENGTH_MESSAGE = `Admin name must be at most ${ADMIN_NAME_MAX_LENGTH} characters.`;
    const TABLE_TEXT_DISPLAY_LIMIT = 30;

    const truncateText = (text) => {
        if (!text) {
            return "";
        }
        return text.length > TABLE_TEXT_DISPLAY_LIMIT
            ? `${text.slice(0, TABLE_TEXT_DISPLAY_LIMIT)}...`
            : text;
    };

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }

        const date = new Date(dateString);

        if (isNaN(date)) {
            return 'Invalid Date';
        }

        const options = {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        };

        return date.toLocaleString('en-GB', options).replace(',', '');
    };

    const convertToCSV = (data) => {
        const header = ["Phone Number", "Cumulated Recharge", "Cumulated Winning", "Cumulated Withdrawal", 'Updated At'];
        const rows = data.map(wallet => [
            wallet.user.mobile,
            wallet.cumulated_recharge,
            wallet.cumulated_winning,
            wallet.cumulated_widthraw,
            wallet.totaltdsDiducted

        ]);

        // Combine header and rows
        const csvContent = [
            header.join(","),  // Join header array into a single string
            ...rows.map(row => row.join(","))
        ].join("\n");  // Join all rows by a newline character

        return csvContent;
    };

    const downloadCSV = () => {
        const csvContent = convertToCSV(AdminDetails);

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Create a link element to trigger the download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", "wallet_data.csv");  // Set filename
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();  // Trigger the download
        document.body.removeChild(link);
    };

    // Function to download Excel
    const downloadExcel = () => {
        const header = ["ID", "Admin Name", "Admin Email", "Admin Phone Number", 'Created At', ''];
        const rows = AdminDetails.map(wallet => ({
            "Phone Number": wallet.user.mobile,
            "Cumulated Recharge": wallet.cumulated_recharge,
            "Cumulated Winning": wallet.cumulated_winning,
            "Cumulated Withdrawal": wallet.cumulated_widthraw,
            'Total Tds Diduceted': wallet.totaltdsDiducted

        }));

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(rows, { header }); // Create a sheet from JSON data
        const wb = XLSX.utils.book_new(); // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, "Wallet Data"); // Append the sheet to the workbook

        // Write the workbook and trigger the download
        XLSX.writeFile(wb, "wallet_data.xlsx"); // This will download the Excel file
    };


    // Only opens the confirmation dialog — no API call yet
    const handleDeleteClick = (data) => {
        setAdminToDelete(data);
    };

    // Cancel: close the dialog, nothing is deleted
    const handleDeleteCancel = () => {
        if (deleting) {
            return;
        }
        setAdminToDelete(null);
    };

    const handleDeleteAdmin = async () => {
        const data = adminToDelete;
        if (!data) {
            return;
        }

        setDeleting(true);
        try {
            const result = await deleteAdminDetails(data.id);
            // deleteAdminDetails returns the raw axios response
            const body = result?.data;

            if (body?.success === false) {
                toast.error(body?.message || "Failed to delete admin. Please try again.", TOAST_OPTIONS);
                return;
            }

            if (result) {
                setAdmin((prev) => prev.filter((admin) => admin.id !== data.id));
                toast.success(body?.message || "Admin deleted successfully.", TOAST_OPTIONS);
                setAdminToDelete(null);
                await getAdmin(currentPage);
            }

        } catch (err) {
            console.error('Error deleting  admin', err);
            toast.error(getApiErrorMessage(err, "Failed to delete admin. Please try again."), TOAST_OPTIONS);
        } finally {
            setDeleting(false);
        }

    }



    const handleToggleAds = async (adminDetail) => {
        setTogglingAdsId(adminDetail.id);
        try {
            const updatedValue = !Boolean(adminDetail.adsEnabled);
            const payload = {
                name: adminDetail.name,
                email: adminDetail.email,
                phoneNumber: adminDetail.phoneNumber,
                adminId: adminDetail.id,
                adsEnabled: updatedValue
            };
            const res = await updateAdminDetails(payload);
            // updateAdminDetails returns the raw axios response
            const body = res?.data;

            if (body?.success === false) {
                toast.error(body?.message || "Failed to update ads status. Please try again.", TOAST_OPTIONS);
                return;
            }

            // update the row right away so the checkbox never lags
            setAdmin((prev) =>
                prev.map((admin) =>
                    admin.id === adminDetail.id ? { ...admin, adsEnabled: updatedValue } : admin
                )
            );

            toast.success(body?.message || "Ads status updated successfully.", TOAST_OPTIONS);

            // then re-sync the listing with whatever the backend now holds
            await getAdmin(currentPage);
        } catch (err) {
            console.error('Error updating  admin adsEnabled', err);
            toast.error(getApiErrorMessage(err, "Failed to update ads status. Please try again."), TOAST_OPTIONS);
            // pull the real state back so the checkbox matches the backend
            await getAdmin(currentPage);
        } finally {
            setTogglingAdsId(null);
        }

    }



    const clearErrors = () => {
        setFormErrors({
            name: "",
            email: "",
            phoneNumber: "",
            password: ""
        });
    };

    // pure — builds the error map without touching state, so the submit
    // button can ask "is this form valid?" on every render
    const buildErrors = (isAdd) => {
        const errors = {
            name: "",
            email: "",
            phoneNumber: "",
            password: ""
        };

        const trimmedName = Name.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        const trimmedPassword = password.trim();

        if (!trimmedName) {
            errors.name = "Name is required.";
        } else if (Name.length > ADMIN_NAME_MAX_LENGTH) {
            errors.name = ADMIN_NAME_MAX_LENGTH_MESSAGE;
        }

        if (!trimmedEmail) {
            errors.email = "Email is required.";
        } else if (trimmedEmail.length < 5 || trimmedEmail.length > 50) {
            errors.email = "Email length must be between 5 and 50 characters.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
            errors.email = "Please enter a valid email address.";
        }

        if (!trimmedPhone) {
            errors.phoneNumber = "Phone number is required.";
        } else if (!/^\d+$/.test(trimmedPhone)) {
            errors.phoneNumber = "Phone number must contain only digits.";
        } else if (trimmedPhone.length !== 10) {
            errors.phoneNumber = "Phone number must be exactly 10 digits.";
        }

        if (isAdd) {
            if (!trimmedPassword) {
                errors.password = "Password is required.";
            } else if (trimmedPassword.length < 6) {
                errors.password = "Password must be at least 6 characters.";
            } else if (!/(?=.*[A-Za-z])(?=.*\d)/.test(trimmedPassword)) {
                errors.password = "Password must include at least one letter and one number.";
            }
        }

        return errors;
    };

    const validateFields = (isAdd) => {
        const errors = buildErrors(isAdd);
        setFormErrors(errors);
        return Object.values(errors).every((value) => value === "");
    };

    // drives the Add / Save button's disabled state
    const isFormValid = Object.values(buildErrors(add)).every((value) => value === "");

    // Save stays off until something actually changed — compared trimmed,
    // since the payload is trimmed too (trailing spaces are not an edit)
    const isFormDirty = !initialForm
        ? false
        : Name.trim() !== (initialForm.name || "").trim() ||
          email.trim() !== (initialForm.email || "").trim() ||
          phoneNumber.trim() !== (initialForm.phoneNumber || "").trim() ||
          Boolean(adsEnabled) !== Boolean(initialForm.adsEnabled);

    const handleClickOpen = (data, check) => {
        setOpen(true);
        setName(data?.name || "");
        setEmail(data?.email || "");
        setPhoneNumber(data?.phoneNumber || "");
        setAdminID(data?.id || "");
        setPassword("");
        clearErrors();
        if (data && typeof data.adsEnabled !== "undefined") {
            setAdsEnabled(Boolean(data.adsEnabled));
        } else {
            setAdsEnabled(true);
        }
        setInitialForm({
            name: data?.name || "",
            email: data?.email || "",
            phoneNumber: data?.phoneNumber || "",
            adsEnabled: data && typeof data.adsEnabled !== "undefined"
                ? Boolean(data.adsEnabled)
                : true,
        });
        if (check === "add") {
            setAdd(true);
        } else {
            setAdd(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setName("");
        setEmail("");
        setPhoneNumber("");
        setAdminID("");
        setAdd(false);
        setPassword("");
        setAdsEnabled(true);
        setInitialForm(null);
        clearErrors();
        // setRechargeAmount("");
        // setNumber("");
    };

    const addAdmin = async () => {
        // guards against a second call slipping in before the re-render
        if (submitting) {
            return;
        }
        if (!validateFields(true)) {
            return;
        }
        setSubmitting(true);
        try {
            const payload = {
                name: Name.trim(),
                email: email.trim(),
                phoneNumber: phoneNumber.trim(),
                password: password.trim(),
                adsEnabled: adsEnabled
            };

            console.log("Payload:", payload);
            const response = await adminCreateApi(payload)
            if (response) {
                alert("Admin created successfully");
            }


            handleClose();
            getAdmin(currentPage);

        } catch (err) {
            console.error("Add admin failed:", err);
            alert("Failed to create admin, please try again.");
        } finally {
            // re-enabled only once the response (or failure) is in
            setSubmitting(false);
        }
    };



    const editAdmin = async () => {
        if (submitting) {
            return;
        }
        if (!validateFields(false)) {
            return;
        }
        const payload = {
            name: Name.trim(),
            email: email.trim(),
            phoneNumber: phoneNumber.trim(),
            adminId: adminId,
            adsEnabled: adsEnabled
            // password: password,
        };

        setSubmitting(true);
        try {
            const response = await updateAdminDetails(payload)
            // updateAdminDetails returns the raw axios response
            const body = response?.data;

            if (body?.success === false) {
                toast.error(body?.message || "Failed to update admin, please try again.", TOAST_OPTIONS);
                return;
            }

            if (response) {
                toast.success(body?.message || "Admin updated successfully.", TOAST_OPTIONS);
            }


            handleClose();
            getAdmin(currentPage);
        } catch (err) {
            console.error("Edit admin failed:", err);
            toast.error(getApiErrorMessage(err, "Failed to update admin, please try again."), TOAST_OPTIONS);
        } finally {
            setSubmitting(false);
        }
    }


    return (
        <div>
            <h1>Admins Management</h1>
            <Button
                variant="contained"
                color="secondary"
                onClick={handleBackClick}
                sx={{ marginBottom: 2 }}
            >
                Back to Dashboard
            </Button>
            {/* <Button
                variant="contained"
                color="primary"
                onClick={downloadCSV}
                sx={{ marginLeft: 7, marginBottom: 2 }}
            >
                Download CSV
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={downloadExcel}
                sx={{ marginLeft: 7, marginBottom: 2 }}
            >
                Download Excel
            </Button> */}
            <Button
                variant="contained"
                color="primary"
                onClick={() => handleClickOpen(null, "add")}
                sx={{ marginLeft: 10, marginBottom: 2, float: 'right' }}
            >
                Add Admin
            </Button>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                <thead>
                    <tr>
                        <th>S.No.</th>
                        <th style={{ textAlign: 'left' }}>Admin Name</th>
                        <th style={{ textAlign: 'left' }}>Admin Email</th>
                        <th>Admin Phone Number</th>
                        <th>Refferal Code</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Ads Enabled</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        // Loader stays until the response lands
                        <tr>
                            <td
                                colSpan={TABLE_COLUMNS}
                                style={{
                                    height: EMPTY_TABLE_HEIGHT,
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                }}
                            >
                                <CircularProgress size={40} />
                            </td>
                        </tr>
                    ) : AdminDetails.length > 0 ? (
                        AdminDetails.map((adminDetail, index) => (
                            <tr key={index}>
                                {/* serial number continues across pages: page 2 starts at 11 */}
                                <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                <td style={{ textAlign: 'left' }}>
                                    <Tooltip title={adminDetail.name || ""}>
                                        <span>{truncateText(adminDetail.name)}</span>
                                    </Tooltip>
                                </td>
                                <td style={{ textAlign: 'left' }}>
                                    <Tooltip title={adminDetail.email || ""}>
                                        <span>{truncateText(adminDetail.email)}</span>
                                    </Tooltip>
                                </td>
                                <td>{adminDetail.phoneNumber}</td>
                                <td>{adminDetail.AdminReferralCode}</td>

                                <td>{formatDate(adminDetail.createdAt)}</td>
                                <td>{formatDate(adminDetail.updatedAt)}</td>
                                <td>
                                    <Checkbox
                                        checked={Boolean(adminDetail.adsEnabled)}
                                        onChange={() => handleToggleAds(adminDetail)}
                                        disabled={togglingAdsId === adminDetail.id}
                                        color="primary"
                                    />
                                </td>
                                <td>
                                    {/* Edit Button */}
                                    <button
                                        onClick={() => handleClickOpen(adminDetail, "edit")} // define handleEdit
                                        style={{
                                            background: 'blue',
                                            color: 'white',
                                            marginRight: '10px',
                                            border: 'none',
                                            padding: '6px 10px',
                                            borderRadius: '5px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <FaEdit />
                                    </button>

                                    {/* Delete Button */}
                                    <button
                                        onClick={() => handleDeleteClick(adminDetail)} // asks for confirmation first
                                        style={{
                                            background: 'red',
                                            color: 'white',
                                            border: 'none',
                                            padding: '6px 10px',
                                            borderRadius: '5px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td
                                colSpan={TABLE_COLUMNS}
                                style={{
                                    height: EMPTY_TABLE_HEIGHT,
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    fontWeight: 500,
                                    color: "#666",
                                }}
                            >
                                No Data Available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* hidden while loading and when there is nothing to page through */}
            {!loading && AdminDetails.length > 0 && (
                <div>
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={loading || currentPage === 1}>
                        Previous
                    </button>
                    <span> Page {currentPage} of {totalPages} </span>
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={loading || currentPage === totalPages}>
                        Next
                    </button>
                </div>
            )}

            <div>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle sx={{ fontWeight: 'bold' }}>{add ? "Add Admin" : "Edit Admin"}</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Name"
                            type="text"
                            required
                            fullWidth
                            value={Name}
                            onChange={(e) => {
                                const value = e.target.value.slice(0, ADMIN_NAME_MAX_LENGTH);
                                setName(value);
                                setFormErrors((prev) => ({
                                    ...prev,
                                    name: value.length > ADMIN_NAME_MAX_LENGTH
                                        ? ADMIN_NAME_MAX_LENGTH_MESSAGE
                                        : ""
                                }));
                            }}
                            sx={{ mt: 2 }}
                            inputProps={{ maxLength: ADMIN_NAME_MAX_LENGTH }}
                            error={Boolean(formErrors.name)}
                            helperText={formErrors.name || `${Name.length}/${ADMIN_NAME_MAX_LENGTH} characters`}
                            FormHelperTextProps={{ sx: { textAlign: 'right' } }}
                        />
                        <TextField
                            label="Email"
                            type="email"
                            required
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ mt: 2 }}
                            inputProps={{ maxLength: 50 }}
                            error={Boolean(formErrors.email)}
                            helperText={formErrors.email}
                        />
                        <TextField
                            label="Phone Number"
                            type="text"
                            required
                            fullWidth
                            value={phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^\d{0,10}$/.test(value)) {
                                    setPhoneNumber(value);
                                }
                            }}
                            sx={{ mt: 2 }}
                            inputProps={{ inputMode: "numeric", maxLength: 10 }}
                            error={Boolean(formErrors.phoneNumber)}
                            helperText={formErrors.phoneNumber}
                        />
                        {add && (
                            <TextField
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                required
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                sx={{ mt: 2 }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClickShowPassword} edge="end">
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                error={Boolean(formErrors.password)}
                                helperText={formErrors.password}
                            />
                        )}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={adsEnabled}
                                    onChange={(e) => setAdsEnabled(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label={
                                <span>
                                    Ads Enabled
                                    {/* matches the asterisk MUI renders on required fields */}
                                    <span style={{ color: '#d32f2f' }}> *</span>
                                </span>
                            }
                            sx={{ mt: 1 }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary" disabled={submitting}>
                            Cancel
                        </Button>
                        {add ? (
                            <Button
                                onClick={addAdmin}
                                color="primary"
                                variant="contained"
                                disabled={!isFormValid || submitting}
                                startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
                            >
                                {submitting ? "Adding..." : "Add"}
                            </Button>
                        ) : (
                            <Button
                                onClick={editAdmin}
                                color="primary"
                                variant="contained"
                                disabled={!isFormValid || !isFormDirty || submitting}
                                startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
                            >
                                {submitting ? "Saving..." : "Save"}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </div>

            {/* Delete confirmation — the API runs only from here */}
            <Dialog open={Boolean(adminToDelete)} onClose={handleDeleteCancel} fullWidth maxWidth="xs">
                <DialogTitle sx={{ fontWeight: 'bold' }}>Delete Admin</DialogTitle>
                <DialogContent>
                    <p style={{ margin: 0 }}>
                        Are you sure you want to delete this admin?
                    </p>
                    {adminToDelete?.name && (
                        <p style={{ marginBottom: 0, fontWeight: 'bold', wordBreak: 'break-word' }}>
                            {adminToDelete.name}
                        </p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="secondary" disabled={deleting}>
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteAdmin} color="error" variant="contained" disabled={deleting}>
                        {deleting ? "Deleting..." : "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>



        </div>
    );

}


export default CreateAdmin;
